












import {Component, Prop} from "vue-property-decorator"
import BaseVue from "@/utils/BaseVue"
import ProductListSelector from "@/components/ProductListSelector.vue"

@Component({components: {ProductListSelector}})
export default class EmptyState extends BaseVue {
    @Prop() private header!: string
    @Prop() private subHeader!: string
}
